<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid" class="p-col-12">
        <div class="p-fluid">
          <div class="p-field">
            <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
          </div>
          <div class="p-field">
            <m-restricao-string label="Origem Id" [restricao]="ds.restricoes.atributo('origemId')"></m-restricao-string>
          </div>
          <div class="p-field">
            <m-restricao-string label="Nome" [restricao]="ds.restricoes.atributo('nome')"></m-restricao-string>
          </div>
          <div class="p-field">
            <m-restricao-string label="Tipo parte" [restricao]="ds.restricoes.atributo('tipoParte.nome')"></m-restricao-string>
          </div>
        </div>
      </div>

      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-lg-6">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-col-12 p-lg-6">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>


  <div class="p-col-12 p-lg-9">
    <p-card header="Lista de Tipos de Parte Local">
    <p-table
      [multiSortMeta]="ds.ordenacoes"
      [value]="ds.entidades"
      [totalRecords]="ds.total"
      (onLazyLoad)="ds.carregar($event)"
      [lazy]="true"
      [(rows)]="ds.registros"
      [paginator]="true"
      responsive="true"
      sortMode="multiple"
      responsiveLayout="scroll"
      styleClass="p-datatable-striped"
      emptyMessage="Nenhum registro encontrado">

      <ng-template pTemplate="header">
        <tr>
          <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
          <th>Origem</th>
          <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
          <th pSortableColumn="tipoParte">Tipo Parte Codex <p-sortIcon field="tipoParte"></p-sortIcon></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-entidade>
        <tr>
          <td class="p-text-center">
            <app-id
              [id]="entidade.id"
              [origemId]="entidade.origemId">
            </app-id>
          </td>
          <td class="text-left" style="font-size: 0.8em;">{{entidade.fonteDados.nome}}</td>
          <td class="text-left">{{entidade.nome}}</td>
          <td class="text-left">
            <span style="font-size: 0.7em; font-style: italic; font-weight: bold;">{{entidade.tipoParte.id}}</span>
            <span style="font-size: 0.8em;"> - {{entidade.tipoParte.nome}}</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="summary">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-col-6" style="text-align: left">
            <button pButton (click)="sincronizar()" class="p-primary" label="Sincronizar"></button>
          </div>
          <div class="p-field p-col p-text-right">
            Quantidade de registros: <span class="p-text-bold"> {{ds.total}}</span>
          </div>
        </div>
      </ng-template>
    </p-table>
  </p-card>
</div>
</div>
